import React from "react";
import "./About.css";
import profileImg from "../../Images/about-img.jpg";
import { ArrowDownTrayIcon } from "@heroicons/react/24/solid";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";
const About = () => {
  return (
    <div className="mx-w-[1440px] mx-auto px-3 pb-5 about">
      <Header></Header>
      <div className="title text-center pt-5 md:pt-20 lg:pt-20">
        <h1 className="text-2xl md:text-4xl lg:text-5xl font-bold">
          ABOUT <span className="text-[orange]">ME</span>{" "}
        </h1>
        <p className="mt-5 text-[12px] md:text-[16px] lg:text-[16px]">
          I DEVELOP AND CODE BEAUTIFUL THINGS, AND I LOVE WHAT I DO.
        </p>
      </div>
      <div className="about-main mt-5 lg:mt-20 md:flex lg:flex">
        <div
          className="img-div flex justify-center md:items-center"
          data-aos="fade-right"
          data-aos-duration="1000"
        >
          <div>
            <span></span>
            <img className="" src={profileImg} alt="img" />
          </div>
        </div>
        <div
          className="about-text flex justify-center items-center"
          data-aos="fade-left"
          data-aos-duration="1000"
        >
          <div>
            <p className="text-[orange] my-2 text-[18px] font-mono">
              Hello i'm Ojit Deb Nath,
            </p>
            <p className="text-justify mt-2 lg:mt-0">
              I am a web developer currently working with react and constantly
              trying to learn new technologies and I like to learn new
              technologies all the time and I feel very happy and want to become
              a good software engineer in future, I am working in web
              development for one year. will be around and I can confidently say
              that I can do my job very well and besides I can definitely learn
              new things if you give me time and if you think I will be a
              perfect work for your company then you can hire me and I will try
              my best in your company. I have created many types of projects in
              my web development which you can see on my portfolio page. <br />
              Thank you
            </p>
            <div className="flex justify-center lg:justify-start mt-5">
              <a
                className="flex items-center text-black bg-[orange] uppercase py-2 px-3 rounded-[20px]"
                href="https://drive.google.com/file/d/1rsNDlYg8NytlCCQHCbtZw6bWD9TnsXan/view?usp=share_link"
                target="_blank"
                rel="noreferrer"
                download="ojit.pdf"
              >
                <ArrowDownTrayIcon className="w-6 h-6 mr-2"></ArrowDownTrayIcon>
                <span>Download my resume</span>
              </a>
            </div>
          </div>
        </div>
      </div>

      <div
        className="mt-10 lg:mt-20"
        id="container-3e8903fa35ca1dbca6ee081c1ecf0dc3"
      ></div>
      {/* native banner ads and this script in index file  */}

      {/* progress bar start  */}
      <div
        className="skills mt-10 lg:mt-20"
        data-aos="fade-up"
        data-aos-duration="3000"
      >
        <h1 className="text-center text-3xl">SKILLS</h1>
        <div className="p-5 rounded-md grid md:grid-cols-2 lg:grid-cols-3 gap-5">
          <div className="skill">
            <h2>Html</h2>
            <div className="progress-bar">
              <div className="html">
                <span>85%</span>
              </div>
            </div>
          </div>

          <div className="skill">
            <h2>CSS</h2>
            <div className="progress-bar">
              <div className="css">
                <span>80%</span>
              </div>
            </div>
          </div>

          <div className="skill">
            <h2>SASS</h2>
            <div className="progress-bar">
              <div className="sass">
                <span>55%</span>
              </div>
            </div>
          </div>

          <div className="skill">
            <h2>botstrap</h2>
            <div className="progress-bar">
              <div className="bootstrap">
                <span>70%</span>
              </div>
            </div>
          </div>

          <div className="skill">
            <h2>Tailwind</h2>
            <div className="progress-bar">
              <div className="tailwind">
                <span>75%</span>
              </div>
            </div>
          </div>

          <div className="skill">
            <h2>jQuery</h2>
            <div className="progress-bar">
              <div className="jquery">
                <span>50%</span>
              </div>
            </div>
          </div>

          <div className="skill">
            <h2>javascript</h2>
            <div className="progress-bar">
              <div className="javascript">
                <span>72%</span>
              </div>
            </div>
          </div>

          <div className="skill">
            <h2>react</h2>
            <div className="progress-bar">
              <div className="react">
                <span>87%</span>
              </div>
            </div>
          </div>

          <div className="skill">
            <h2>mogodb</h2>
            <div className="progress-bar">
              <div className="mongodb">
                <span>70%</span>
              </div>
            </div>
          </div>

          <div className="skill">
            <h2>node js</h2>
            <div className="progress-bar">
              <div className="nodejs">
                <span>60%</span>
              </div>
            </div>
          </div>

          <div className="skill">
            <h2>express js</h2>
            <div className="progress-bar">
              <div className="expressjs">
                <span>75%</span>
              </div>
            </div>
          </div>

          <div className="skill">
            <h2>Firebase</h2>
            <div className="progress-bar">
              <div className="firebase">
                <span>65%</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer></Footer>
    </div>
  );
};

export default About;
